// import * as Config from '../../../../config';
import { useCallback, useContext } from "react";
import { ReactReduxContext } from 'react-redux';

import { setPlaylistAutomix, setRandomAutomix } from "../redux/actions/index";

// ON LIST
const useCallbackAutomix = (uid) => {
  const { store } = useContext(ReactReduxContext)
  const { getState, dispatch } = store

  const callback = useCallback( (isToggle) => {
    const state = getState();
    let isAllowed = true;

    if (isToggle) {
      const selectStack = (Array.isArray(state.stackAutomix)) ? state.stackAutomix.find( x => x.uid === uid ) : state.stackAutomix;
      if (selectStack) {
        // let tracks = (state.isRandomAutomix) ? Config.shuffle(selectStack.tracks.filter(x => (x.length_s && !x.recommended))) : selectStack.tracks.filter(x => (x.length_s && !x.recommended));
        let tracks = selectStack.tracks.filter(x => (x.length_s && !x.recommended));
        dispatch(setPlaylistAutomix({ ...selectStack, tracks, active: 0 /*null*/ }));
        dispatch(setRandomAutomix(false));
        isAllowed = (tracks.length > 0)
      }
    }
    if(isAllowed) {
      try {
        window['YouDJ'] && window['YouDJ'].automix_toggle(uid);
      } catch {}
    }
    return isAllowed;
  }, [getState, dispatch, uid]);

  return callback;
}

export default useCallbackAutomix;
